import Web3 from "web3";
import { init, useOnboard } from "@web3-onboard/vue";
import injectedModule from "@web3-onboard/injected-wallets";
import walletConnectModule from "@web3-onboard/walletconnect";

const injected = injectedModule();
const walletConnect = walletConnectModule({
  // https://onboard.blocknative.com/docs/wallets/walletconnect
  version: 2,
  /**
   * Project ID associated with [WalletConnect account](https://cloud.walletconnect.com)
   */
  projectId: "caf2871eccf667e9c29298c9468a421c",
  /**
   * Optional function to handle WalletConnect URI when it becomes available
   */
  // handleUri: (uri) => console.log(uri),
  /**
   * Chains required to be supported by all wallets connecting to your DApp
   */
  requiredChains: [1],
});
window.web3Onboard = init({
  wallets: [injected, walletConnect],
  accountCenter: {
    desktop: {
      enabled: false,
    },
    mobile: {
      enabled: false,
    },
  },
  chains: [
    {
      id: "0x1",
      token: "ETH",
      label: "Ethereum Mainnet",
      rpcUrl: "https://rpc.mevblocker.io/norefunds",
    },
    {
      id: "0xa4b1",
      token: "ETH",
      label: "Arbitrum One Mainnet",
      rpcUrl: "https://1rpc.io/arb",
    },
  ],
  theme: {
    "--w3o-background-color": "#141519",
    "--w3o-foreground-color": "#1e1f24",
    "--w3o-text-color": "#ffffff",
    "--w3o-border-color": "#5b5b5b",
    "--w3o-action-color": "#7186d2",
    "--w3o-border-radius": "unset",
    "--w3o-font-family": "unset",
  },
  appMetadata: {
    name: "Hyperbolic Protocol",
    description:
      "Hyperbolic Protocol (HYPE) is the first-of-its-kind 100% fully on-chain collateralized lending protocol that leverages built-in Uniswap V3 TWAPs to drive automated variable APRs and protocol usage fees to maximize yield, protocol growth, and ultimately sustainability.",
    icon: "/hyperbolic-logo.svg",
  },
});
const onboardInfo = useOnboard();
injectedModule();

const NOOP = () => {};

export default {
  provider: null,
  web3: null,

  async connect() {
    if (this.provider && this.web3) {
      return { provider: this.provider, web3: this.web3 };
    }

    const { connectWallet, connectedWallet } = onboardInfo;
    await connectWallet();

    this.provider = connectedWallet.value.provider;
    this.web3 = new Web3(connectedWallet.value.provider);
    return { provider: this.provider, web3: this.web3 };
  },

  bindProviderEvents({
    accountsChanged,
    chainChanged,
    connect,
    disconnect,
  }) {
    if (!this.provider) {
      throw new Error(
        `Make sure to connect first before binding provider events.`
      );
    }

    this.provider.on("accountsChanged", accountsChanged || NOOP);
    this.provider.on("chainChanged", chainChanged || NOOP);
    this.provider.on("connect", connect || NOOP);
    this.provider.on("disconnect", disconnect || NOOP);
  },

  async clearCachedProvider() {
    this.provider = null;
    this.web3 = null;

    const { alreadyConnectedWallets, disconnectWallet } = onboardInfo;
    const walletsToDisconnect = alreadyConnectedWallets.value;

    if (!walletsToDisconnect || !Array.isArray(walletsToDisconnect)) {
      return;
    }

    for await (const w of walletsToDisconnect) {
      await disconnectWallet({ label: w });
    }
  },
};
